import {createSelector, MemoizedSelector} from '@ngrx/store';
import { geRiderEventsState, } from '@app/store/faxe/faxe-selectors';
import {RiderEvent} from '@app/rest-client/faxe/models/rider-event';
import {selectAllRiderEvent} from '@app/store/faxe/rider-event/rider-event.reducer';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { defined } from '@app/fremework/functions';

export const selectRiderEventAll: MemoizedSelector<object, RiderEvent[]> = createSelector(
  geRiderEventsState,
  selectAllRiderEvent
);

export const selectRidersEventState =
  ():
    MemoizedSelector<object, { riderEvents: RiderEvent[], sliceState: SliceState }> =>
    createSelector(
      geRiderEventsState,
      selectRiderEventAll,
      (state, all) => ({
        riderEvents: all,
        sliceState: state?.meta?.sliceState
      })
    );

export const selectRiderEventByRaceGuid =
  (raceGuid: string, sliceState: SliceState):
    MemoizedSelector<object, RiderEvent[]> =>
    createSelector(
      geRiderEventsState,
      selectRiderEventAll,
      (state, all) =>
        all
          .filter(riderEvent => (defined(state?.meta?.sliceState) &&
              (state.meta.sliceState === SliceState.total || sliceState === SliceState.reportable))
            && riderEvent.raceGuid === raceGuid)
    );



